/** @webpackPreprocess */
module.exports = {
	baseUrl: '',
	// baseUrl: "http://10.0.7.50:8787/api/", //本地
	// baseUrl:"http://192.168.31.243:8383/api/",//本地
	// baseUrl:"http://10.0.7.202:8484/api/",//测试
	// baseUrl:"http://222.27.186.88/api/",//校园网
	timeout: 15 * 1000,
	// type:{
	// 	titleImg:require('@/assets/home/title-hs.png'),
	// 	logo:require('@/assets/home/logo-hs.png'),
	// 	title:'哈尔滨商业大学项目评审与过程管理平台',
	// 	copyright:'哈尔滨商业大学'
	// },
	type: {
		titleImg: require('@/assets/home/title.png'),
		logo: require('@/assets/home/logo-hj.png'),
		title: '新文科实践创新大赛信息平台',
		copyright: '实践教学智慧平台'
	},
	// type:{
	// 	titleImg:require('@/assets/home/title.png'),
	// 	logo:require('@/assets/home/logo.png'),
	// 	title:'实验教学和教学实验室建设研究项目管理系统',
	// 	copyright:'高等学校教学实验室数据管理平台'
	// }
}